<template>
  <div class="bg-block shadow-primaryBlock rounded
   px-8 py-9 lg:px-12 lg:py-13
   mb-8 lg:mb-12">
    <MyBudgetsTitle :is-created="isCreated"
                    :widget-data="widgetData"/>
    <MyBudgetsPreview v-if="isCreated"
                      :days-passed="widgetData.daysPassed"
                      :money-spent="widgetData.moneySpent"
                      :color="widgetData.color"/>
    <MyBudgetsEmpty v-else/>
  </div>
</template>

<script>
import MyBudgetsTitle from "@/components/cabinet/Money/Dashboard/MyBudgets/MyBudgetsTitle";
import MyBudgetsPreview from "@/components/cabinet/Money/Dashboard/MyBudgets/MyBudgetsPreview/MyBudgetsPreview";
import MyBudgetsEmpty from "@/components/cabinet/Money/Dashboard/MyBudgets/MyBudgetsEmpty";
import {mapActions, mapState} from "vuex";

export default {
  name: "MyBudgets",
  components: {
    MyBudgetsEmpty, MyBudgetsPreview, MyBudgetsTitle
  },
  computed: {
    ...mapState('moneyDashboard/budgetWidget', ['widgetData', 'isCreated']),
  }
}
</script>
